export default __webpack_public_path__ + "static/media/person_2@3x.c163a23b.png";